import { useState } from 'react';

export default function CTASection() {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    email: '',
    servicio: '',
    fecha: '',
    mensaje: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d6enbfrv53dtlm7j99a0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nombre: '',
          telefono: '',
          email: '',
          servicio: '',
          fecha: '',
          mensaje: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <section id="reserva" className="py-24 bg-[#A8B5A0]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="font-serif text-5xl font-bold text-white mb-4">
            ¿Listo para sentirte mejor que nunca?
          </h2>
          <div className="flex items-center justify-center space-x-8 text-white/90 text-lg">
            <div className="flex items-center">
              <i className="ri-map-pin-line mr-2 text-xl"></i>
              <span>C. Gral. Castaños, 1, Getafe</span>
            </div>
            <div className="flex items-center">
              <i className="ri-phone-line mr-2 text-xl"></i>
              <span>643 218 449</span>
            </div>
          </div>
        </div>

        {/* Booking Form */}
        <div className="max-w-3xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-2xl">
          <h3 className="font-serif text-3xl font-semibold text-[#2C3E2F] mb-2 text-center">
            Reserva tu sesión
          </h3>
          <p className="text-gray-600 text-center mb-8">
            Completa el formulario y nos pondremos en contacto contigo para confirmar tu cita
          </p>

          <form id="booking-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="nombre" className="block text-sm font-semibold text-[#2C3E2F] mb-2">
                  Nombre completo *
                </label>
                <input
                  type="text"
                  id="nombre"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#A8B5A0] focus:outline-none transition-colors text-sm"
                  placeholder="Tu nombre"
                />
              </div>

              <div>
                <label htmlFor="telefono" className="block text-sm font-semibold text-[#2C3E2F] mb-2">
                  Teléfono *
                </label>
                <input
                  type="tel"
                  id="telefono"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#A8B5A0] focus:outline-none transition-colors text-sm"
                  placeholder="643 218 449"
                />
              </div>
            </div>

            <div>
              <label htmlFor="email" className="block text-sm font-semibold text-[#2C3E2F] mb-2">
                Email *
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#A8B5A0] focus:outline-none transition-colors text-sm"
                placeholder="tu@email.com"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="servicio" className="block text-sm font-semibold text-[#2C3E2F] mb-2">
                  Tipo de masaje *
                </label>
                <select
                  id="servicio"
                  name="servicio"
                  value={formData.servicio}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#A8B5A0] focus:outline-none transition-colors text-sm cursor-pointer"
                >
                  <option value="">Selecciona un servicio</option>
                  <option value="Masaje Descontracturante">Masaje Descontracturante</option>
                  <option value="Masaje Relajante">Masaje Relajante</option>
                  <option value="Masaje Deportivo">Masaje Deportivo</option>
                </select>
              </div>

              <div>
                <label htmlFor="fecha" className="block text-sm font-semibold text-[#2C3E2F] mb-2">
                  Fecha preferida *
                </label>
                <input
                  type="date"
                  id="fecha"
                  name="fecha"
                  value={formData.fecha}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#A8B5A0] focus:outline-none transition-colors text-sm cursor-pointer"
                />
              </div>
            </div>

            <div>
              <label htmlFor="mensaje" className="block text-sm font-semibold text-[#2C3E2F] mb-2">
                Mensaje adicional (opcional)
              </label>
              <textarea
                id="mensaje"
                name="mensaje"
                value={formData.mensaje}
                onChange={handleChange}
                maxLength={500}
                rows={4}
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#A8B5A0] focus:outline-none transition-colors resize-none text-sm"
                placeholder="Cuéntanos si tienes alguna necesidad específica o preferencia de horario..."
              ></textarea>
              <p className="text-xs text-gray-500 mt-1">
                Máximo 500 caracteres ({formData.mensaje.length}/500)
              </p>
            </div>

            {submitStatus === 'success' && (
              <div className="bg-green-50 border-2 border-green-200 rounded-xl p-4 text-center">
                <i className="ri-checkbox-circle-line text-3xl text-green-600 mb-2"></i>
                <p className="text-green-800 font-semibold">
                  ¡Reserva enviada con éxito!
                </p>
                <p className="text-green-700 text-sm mt-1">
                  Nos pondremos en contacto contigo pronto para confirmar tu cita.
                </p>
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="bg-red-50 border-2 border-red-200 rounded-xl p-4 text-center">
                <i className="ri-error-warning-line text-3xl text-red-600 mb-2"></i>
                <p className="text-red-800 font-semibold">
                  Hubo un error al enviar tu reserva
                </p>
                <p className="text-red-700 text-sm mt-1">
                  Por favor, inténtalo de nuevo o llámanos al 643 218 449
                </p>
              </div>
            )}

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full py-4 bg-[#2C3E2F] text-white font-semibold rounded-xl hover:bg-[#3d5442] transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
            >
              {isSubmitting ? (
                <span className="flex items-center justify-center">
                  <i className="ri-loader-4-line animate-spin mr-2"></i>
                  Enviando...
                </span>
              ) : (
                <span className="flex items-center justify-center">
                  <i className="ri-send-plane-fill mr-2"></i>
                  Enviar reserva
                </span>
              )}
            </button>
          </form>

          <div className="mt-8 text-center">
            <p className="text-gray-600 mb-4">O contáctanos directamente por WhatsApp</p>
            <a
              href="https://wa.me/34643218449?text=Hola,%20me%20gustaría%20reservar%20una%20cita%20para%20un%20masaje"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-8 py-3 bg-[#25D366] text-white font-semibold rounded-full hover:bg-[#20BA5A] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-2 text-xl"></i>
              Quiero reservar mi sesión
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
